import { render, staticRenderFns } from "./DashboardInfo.vue?vue&type=template&id=48fa56ca&scoped=true"
import script from "./DashboardInfo.vue?vue&type=script&lang=js"
export * from "./DashboardInfo.vue?vue&type=script&lang=js"
import style0 from "./DashboardInfo.vue?vue&type=style&index=0&id=48fa56ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa56ca",
  null
  
)

export default component.exports